<div class="container">
  <div class="register-image-div">
    <img
      class="register-logo"
      [src]="env['logo_paths']['loginPagePic']"
      alt="Register logo"
    />
  </div>
  <div class="form-div">
    <form
      fxLayout="column"
      [formGroup]="registerForm"
      #form="ngForm"
      (ngSubmit)="submit(form)"
      #formDirective="ngForm"
    >
      <!-- Email Input -->
      <mat-form-field appearance="fill">
        <mat-label>Username</mat-label>
        <input
          matInput
          placeholder="mb07"
          name="username"
          formControlName="username"
          required
        />
        <mat-error *ngIf="registerForm.invalid">Required</mat-error>
      </mat-form-field>

      <!-- Password Input -->
      <mat-form-field appearance="fill">
        <mat-label>Password</mat-label>
        <input
          matInput
          name="password"
          formControlName="password"
          [type]="hide ? 'password' : 'text'"
          required
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Confirm your password</mat-label>
        <input
          matInput
          name="password"
          formControlName="password_confirm"
          [type]="hide ? 'password' : 'text'"
          required
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>First name</mat-label>
        <input
          matInput
          name="first-name"
          formControlName="first_name"
          required
        />
        <mat-error *ngIf="registerForm.invalid">Required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Last name</mat-label>
        <input matInput name="last-name" formControlName="last_name" required />
        <mat-error *ngIf="registerForm.invalid">Required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Authorization code</mat-label>
        <input matInput name="auth-code" formControlName="auth_code" required />
        <mat-error *ngIf="registerForm.invalid">Required</mat-error>
      </mat-form-field>

      <!-- <mat-form-field appearance="fill">
        <mat-label>User access</mat-label>
        <mat-select
          [(value)]="accessSelected"
          formControlName="role"
          [disabled]="true"
          required
        >
          <mat-option value="admin"> Administrator </mat-option>
          <mat-option value="student"> Student </mat-option>
          <mat-option value="pamlab"> PAM Lab </mat-option>
          <mat-option value="guest_admin"> Guest Admin </mat-option>
          <mat-option value="guest"> Guest </mat-option>
        </mat-select>
        <mat-error *ngIf="registerForm.invalid">Required</mat-error>
      </mat-form-field> -->

      <!-- <mat-error *ngIf="showError">{{ errorMessage }}</mat-error> -->

      <!-- Submit Button -->
      <div class="submit-button-div">
        <button
          [style.backgroundColor]="env['colors']['primary']"
          class="submitButton"
          type="submit"
          [disabled]="!form.valid"
          mat-raised-button
        >
          Register
        </button>
      </div>
    </form>
    <p>
      To go back to login page
      <a routerLink="/login" routerLinkActive="active">click here</a>
    </p>
  </div>
</div>
